{
  "nav": {
    "home": "Home",
    "events": "Events",
    "music": "Music",
    "sets": "Sets",
    "drops": "Drops",
    "about": "About",
    "press": "Press kit",
    "booking": "Booking",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "skipToContent": "Skip to content",
    "venues": "Venues",
    "rider": "DJ rider",
    "livesets": "Sets",
    "links": "Links",
    "mobile": "Main navigation"
  },
  "lang": {
    "label": "Language",
    "en": "EN",
    "de": "DE"
  },
  "hero": {
    "ctaEvents": "Upcoming Events",
    "ctaBooking": "Book Ajay",
    "scroll": "Scroll"
  },
  "events": {
    "eyebrow": "Live",
    "title": "Events",
    "all": "All events",
    "empty": "No upcoming events right now. Follow on Instagram for the next date.",
    "past": "Past Events",
    "minAge": "{{age}}+",
    "badge": {
      "live": "Live now",
      "guestlistOpen": "Guestlist open",
      "guestlistFull": "Waitlist",
      "tickets": "Tickets",
      "past": "Past"
    },
    "detail": {
      "back": "All events",
      "date": "Date",
      "time": "Time",
      "doors": "{{start}} – {{end}}",
      "venue": "Venue",
      "lineup": "Line-up",
      "age": "Age",
      "dresscode": "Dress code",
      "googleMaps": "Google Maps",
      "appleMaps": "Apple Maps",
      "joinGuestlist": "Join Guestlist",
      "joinWaitlist": "Join Waitlist",
      "guestlistClosed": "Guestlist closed",
      "externalTickets": "Get Tickets",
      "addToCalendar": "Add to Calendar",
      "share": "Share",
      "copied": "Link copied",
      "calendarApple": "Apple / Outlook (.ics)",
      "calendarGoogle": "Google Calendar",
      "startsIn": "Starts in",
      "liveNow": "Happening now",
      "archived": "This event has already taken place.",
      "days": "Days",
      "hours": "Hrs",
      "minutes": "Min",
      "seconds": "Sec",
      "about": "About the event",
      "waitlistInfo": "The guestlist is full. You can join the waitlist and will be notified if a spot opens up.",
      "spotsLeft": "{{count}} spots left",
      "noLineup": "TBA"
    },
    "guestlist": "Guestlist"
  },
  "tiles": {
    "eyebrow": "Explore",
    "title": "Everything AJAY"
  },
  "music": {
    "eyebrow": "Listen",
    "title": "Music",
    "spotifyTodo": "Spotify artist embed appears here once the Spotify URL is added.",
    "consent": "Plays via Spotify. Data is only sent to Spotify after you tap.",
    "soundcloud": "SoundCloud",
    "playlists": "Playlists"
  },
  "sets": {
    "eyebrow": "Watch",
    "title": "Sets & Video",
    "play": "Play video",
    "consent": "Plays via YouTube (youtube-nocookie.com). Data is only sent to YouTube after you tap.",
    "watchLive": "Watch live on Twitch",
    "latest": "Latest uploads"
  },
  "drops": {
    "eyebrow": "For DJs",
    "title": "Drops",
    "getIt": "Get it"
  },
  "about": {
    "eyebrow": "A little",
    "title": "About me",
    "genres": "Genres",
    "photosTodo": "TODO: photos"
  },
  "booking": {
    "eyebrow": "Booking",
    "title": "Book Ajay",
    "intro": "Club, festival, private or corporate – tell me about your event.",
    "orMail": "Or write directly to",
    "fields": {
      "name": "Name",
      "company": "Company / promoter",
      "email": "Email",
      "phone": "Phone",
      "eventType": "Type of event",
      "date": "Date",
      "location": "City / venue",
      "setLength": "Set length",
      "expectedGuests": "Expected guests",
      "budget": "Budget",
      "message": "Message",
      "privacy": "I have read the <1>privacy policy</1> and agree to my data being processed to handle my request.",
      "website": "Leave this field empty"
    },
    "optional": "optional",
    "select": "Please choose",
    "eventTypes": {
      "club": "Club",
      "festival": "Festival",
      "private": "Private",
      "corporate": "Corporate",
      "wedding": "Wedding",
      "other": "Other"
    },
    "budgets": {
      "lt500": "Under €500",
      "500to1000": "€500 – €1,000",
      "1000to2000": "€1,000 – €2,000",
      "gt2000": "Over €2,000",
      "tbd": "To be discussed"
    },
    "submit": "Send request",
    "successTitle": "Request sent!",
    "successText": "Thanks, {{name}}. You'll get a confirmation at {{email}} – I'll get back to you soon.",
    "another": "Send another request"
  },
  "support": {
    "text": "Enjoying the sets and edits?",
    "button": "Support me"
  },
  "footer": {
    "imprint": "Imprint",
    "privacy": "Privacy",
    "terms": "Terms",
    "rights": "All rights reserved."
  },
  "press": {
    "eyebrow": "Press",
    "title": "Press Kit 2026",
    "short": "Short bio",
    "long": "Long bio",
    "download": "Download press kit (PDF)",
    "pdfTodo": "TODO: press kit PDF is uploaded in the admin.",
    "photos": "Press photos",
    "onRequest": "High-resolution photos and videos on request:"
  },
  "legal": {
    "imprint": "Imprint",
    "privacy": "Privacy Policy",
    "terms": "Terms & Conditions"
  },
  "admin": {
    "nav": {
      "dashboard": "Home",
      "events": "Events",
      "inbox": "Inbox",
      "design": "Design",
      "links": "Links",
      "content": "Texts",
      "viewSite": "View website"
    },
    "auth": {
      "title": "Sign in",
      "email": "Email",
      "password": "Password",
      "signIn": "Sign in",
      "google": "Continue with Google",
      "forgot": "Forgot password?",
      "resetSent": "Password reset email sent.",
      "enterEmailFirst": "Enter your email first.",
      "wrongCredentials": "Wrong email or password.",
      "tooMany": "Too many attempts. Try again later.",
      "failed": "Sign-in failed. Please try again.",
      "signOut": "Sign out",
      "noAccessTitle": "No access",
      "noAccessText": "You're signed in as {{email}}. If this e-mail is on the admin list, activate your access here.",
      "devHint": "Local test login:",
      "activate": "Activate admin access",
      "notAllowed": "This account isn't on the admin list. Ask the developer to add your e-mail to ADMIN_EMAILS and deploy the functions again."
    },
    "common": {
      "all": "All",
      "close": "Close",
      "delete": "Delete",
      "deleted": "Deleted.",
      "discard": "Discard",
      "dragToSort": "Drag to reorder",
      "edit": "Edit",
      "english": "English (required)",
      "germanOptional": "German (optional – falls back to English)",
      "error": "Something went wrong. Please try again.",
      "language": "Language",
      "optional": "(optional)",
      "save": "Save",
      "saved": "Saved.",
      "saving": "Saving…",
      "unsaved": "Unsaved changes",
      "view": "View"
    },
    "dashboard": {
      "title": "Hi Ajay 👋",
      "upcoming": "Upcoming",
      "guests": "Guests",
      "newBookings": "New requests",
      "nextEvents": "Next events",
      "noEvents": "No upcoming events.",
      "latestBookings": "Latest booking requests"
    },
    "events": {
      "new": "New event",
      "untitled": "New event",
      "upcoming": "Upcoming",
      "past": "Past",
      "none": "No events here yet.",
      "notFound": "Event not found.",
      "draft": "Draft",
      "published": "Published",
      "publishHint": "Only published events are visible on the website.",
      "guestlist": "Guestlist",
      "basics": "Basics",
      "title": "Title",
      "slug": "Link",
      "starts": "Start",
      "ends": "End",
      "viennaTime": "(Vienna time)",
      "venue": "Location",
      "venueName": "Venue name",
      "address": "Address",
      "mapsUrl": "Google Maps link",
      "details": "Details",
      "description": "Description",
      "lineup": "Line-up",
      "lineupHint": "(one name per line)",
      "minAge": "Minimum age",
      "dresscode": "Dress code (optional)",
      "flyer": "Flyer",
      "flyerUpload": "Flyer image",
      "flyerHint": "(cropped to 4:5 automatically)",
      "guestlistEnabled": "Guestlist active",
      "capacity": "Capacity (people)",
      "maxPlusOnes": "Max. plus-ones",
      "deadline": "Deadline",
      "countInfo": "Currently on the list: {{count}} people (incl. plus-ones).",
      "tickets": "Tickets",
      "externalUrl": "External ticket link",
      "ticketsDeferred": "Own ticket sales via PayPal will follow as a later feature.",
      "delete": "Delete event",
      "confirmDelete": "Really delete \"{{title}}\" including its guestlist? This cannot be undone.",
      "errors": {
        "title": "Please enter a title.",
        "slug": "Link: only lowercase letters, numbers and dashes.",
        "slugTaken": "This link is already used by another event.",
        "dates": "The end must be after the start.",
        "minAge": "Minimum age must be a number.",
        "guestlist": "Guestlist: capacity at least 1, plus-ones 0–10.",
        "url": "Please enter links starting with https://",
        "venue": "Published events need a venue name."
      },
      "noSignupHint": "Without a guestlist link, the event page has no sign-up button.",
      "guestlistLink": "Guestlist link",
      "guestlistLinkHint": "(e.g. getguestlist.io – replaces the own guestlist)",
      "flyerBundled": "No flyer yet. Flyers ship with the website, named after the event day: {{file}}"
    },
    "guestlist": {
      "confirmed": "Confirmed",
      "waitlist": "Waitlist",
      "checkedIn": "Checked in",
      "search": "Search name or email",
      "filter": "Filter",
      "empty": "Nobody on the list yet.",
      "noMatch": "No matches.",
      "checkIn": "Check in",
      "in": "In",
      "promote": "Move {{name}} from waitlist to guestlist",
      "promoted": "{{name}} is now on the guestlist.",
      "confirmOverCapacity": "This exceeds the capacity. Add to the guestlist anyway?",
      "confirmDelete": "Remove {{name}} from the list?",
      "print": "Print",
      "sendList": "Send list",
      "listSent": "Guest list sent by e-mail ({{count}} entries).",
      "name": "Name",
      "statusCol": "Status",
      "phone": "Phone"
    },
    "inbox": {
      "empty": "No booking requests yet.",
      "reply": "Reply by email",
      "statusLabel": "Status",
      "notes": "Internal notes",
      "confirmDelete": "Delete the request from {{name}}?",
      "status": {
        "new": "New",
        "inProgress": "In progress",
        "confirmed": "Confirmed",
        "declined": "Declined"
      }
    },
    "design": {
      "subtitle": "Changes appear in the preview first and go live with “Publish”.",
      "preview": "Preview",
      "livePreview": "Live preview",
      "publish": "Publish",
      "published": "Published – the website is updated.",
      "brand": "Brand",
      "accent": "Accent colour",
      "presets": "Colour presets",
      "invalidColor": "Please choose a valid colour.",
      "logo": "Logo",
      "logoHint": "(SVG or PNG, transparent)",
      "marquee": "Marquee text",
      "hero": "Hero",
      "headline": "Headline",
      "subline": "Subline",
      "quote": "Claim / quote",
      "heroMedia": "Hero media",
      "none": "None",
      "image": "Image",
      "video": "Video",
      "heroImage": "Portrait (cut-out)",
      "heroVideo": "Hero video",
      "videoHint": "(MP4, ideally under 3 MB)",
      "poster": "Poster image",
      "posterHint": "(shown while the video loads)",
      "background": "Background",
      "color": "Colour",
      "gradient": "Gradient",
      "angle": "Angle",
      "addColor": "Add colour",
      "removeColor": "Remove colour",
      "overlay": "Darkening",
      "overlayHint": "At least 40 % darkening keeps text readable on any image.",
      "sections": "Sections",
      "sectionsHint": "Drag to reorder, eye icon to show or hide. The hero always comes first.",
      "hidden": "hidden",
      "sectionNames": {
        "marquee": "Marquee",
        "events": "Upcoming events",
        "tiles": "Tiles",
        "music": "Music",
        "sets": "Sets & video",
        "drops": "Drops",
        "about": "About",
        "booking": "Booking",
        "support": "Support",
        "instagram": "Instagram",
        "info": "Main info",
        "stats": "Media statistics",
        "venues": "Venues played",
        "rider": "DJ rider",
        "livesets": "Live DJ sets",
        "lection": "LECTION",
        "contact": "Contact",
        "artists": "Artist support",
        "produced": "Produced by Ajay",
        "links": "Links (Linktree)"
      },
      "style": "Look",
      "styles": {
        "sand": "Sand (press kit)",
        "dark": "Dark (club)"
      },
      "styleHint": "Sand uses the press-kit colours and ignores the background settings below.",
      "defaultHint": "Leave empty to use the press-kit version.",
      "heroImageHint": "(PNG with transparent or sand-coloured background)",
      "line1": "Line 1 under the logo",
      "line2": "Line 2 under the logo"
    },
    "links": {
      "add": "Add link",
      "edit": "Edit link",
      "title": "Title",
      "subtitle": "Subtitle",
      "subtitleHint": "Drag to reorder, eye to hide. Changes are live immediately.",
      "category": "Category",
      "icon": "Icon",
      "cover": "Cover image",
      "visible": "Visible on the website",
      "empty": "No links in this category.",
      "invalid": "Please enter a title and a link starting with https://",
      "confirmDelete": "Delete \"{{title}}\"?",
      "hide": "Hide {{title}}",
      "show": "Show {{title}}",
      "categories": {
        "social": "Social",
        "streaming": "Streaming",
        "sets": "Sets",
        "drops": "Drops"
      }
    },
    "content": {
      "tabs": {
        "general": "General",
        "about": "Bio",
        "press": "Press kit",
        "tiles": "Tiles",
        "legal": "Legal"
      },
      "artistName": "Artist name",
      "bookingEmail": "Booking email",
      "spotify": "Spotify artist link",
      "spotifyHint": "(enables the Spotify player)",
      "lection": "LECTION link",
      "support": "PayPal.me link",
      "genres": "Genres",
      "genresHint": "(comma separated)",
      "invalidEmail": "Please enter a valid booking email.",
      "bioShort": "Short bio",
      "bioLong": "Long bio (press kit)",
      "aboutPhotos": "About photos (max. 4)",
      "pressPdf": "Press kit PDF",
      "pressPdfHint": "(max. 20 MB)",
      "pressPhotos": "Press photos",
      "tilesHint": "Tap a tile to edit it, drag to reorder.",
      "tileHref": "Target",
      "tileHrefHint": "(e.g. /#music, /press or https://…)",
      "tileImage": "Image",
      "legalHint": "Legal texts must be checked by Ajay or a lawyer. Imprint is mandatory in Austria.",
      "linkPrompt": "Link (empty to remove):",
      "factsTitle": "Main info",
      "factsEn": "Facts (English)",
      "factsDe": "Facts (German, optional)",
      "factsDeHint": "(same line as the English fact)",
      "onePerLine": "(one per line)",
      "infoPhoto": "Main info photo",
      "statsTitle": "Media statistics",
      "statPlatform": "Platform",
      "statLabel": "Label",
      "statValue": "Number",
      "statAdd": "Add row",
      "venuesTitle": "Venues played",
      "venuesPhoto": "Venues photo",
      "riderTitle": "DJ rider",
      "riderGear": "Gear",
      "riderNote": "Note for promoters",
      "liveSets": "Live sets playlist (YouTube)",
      "contactPhoto": "Contact photo",
      "riderPhoto": "Photo of the setup",
      "statUrl": "Link to the profile",
      "artistsTitle": "Artist support",
      "artistsList": "Artists",
      "artistsPhoto": "Photo for artist support",
      "producedTitle": "Produced by Ajay",
      "remixes": "Remixes (left)",
      "tracks": "Productions (right)",
      "producedPhoto": "Photo (cut-out)",
      "contactUrl": "“Click here” link (contact)",
      "contactUrlHint": "(empty = booking form)",
      "guestlistUrl": "Default guestlist link",
      "guestlistUrlHint": "(for events without their own link)",
      "pressKitUrl": "Press kit link (pCloud)"
    },
    "media": {
      "upload": "Upload",
      "replace": "Replace",
      "remove": "Remove",
      "failed": "Upload failed.",
      "tooLarge": "File is too large (max. {{mb}} MB).",
      "videoHeavy": "Note: videos over 3 MB slow down the page on mobile.",
      "addPhotos": "Add photos",
      "uploading": "{{count}} left…",
      "orLink": "… or paste an image link",
      "disabled": "Image upload is switched off for now (needs the Firebase Blaze plan). Images ship with the website – send them to Claude.",
      "removeOld": "Remove old upload"
    },
    "feeds": {
      "title": "Automatic content",
      "intro": "New YouTube uploads and Instagram posts appear on the website automatically (checked every hour).",
      "syncNow": "Sync now",
      "youtubeHint": "Latest uploads of the YouTube channels in your social links.",
      "instagramHint": "Needs an Instagram professional account (Business/Creator) and an access token from the Meta developer dashboard (Instagram API with Instagram Login). The token is stored securely and renewed automatically.",
      "videos": "videos",
      "posts": "posts",
      "lastSync": "Last sync {{date}} · {{count}} {{label}}",
      "never": "Not synced yet.",
      "connected": "Connected",
      "notConnected": "Not connected",
      "token": "Access token",
      "replaceToken": "Replace access token",
      "connect": "Connect",
      "tokenInvalid": "That doesn't look like a valid token.",
      "tokenSaved": "Token saved.",
      "synced": "Synced: {{videos}} videos, {{posts}} posts.",
      "disconnect": "Disconnect Instagram",
      "confirmDisconnect": "Remove the Instagram token? Posts already on the site stay until the next sync.",
      "disconnected": "Instagram disconnected."
    },
    "import": {
      "title": "Set up the website",
      "text": "The database is still empty. Import the starting content: all links from the Linktree, texts, design and section order. Everything can be edited afterwards; nothing existing is overwritten.",
      "button": "Import starting content",
      "done": "Starting content imported."
    },
    "scan": {
      "open": "Scanner",
      "counter": "{{in}} / {{total}} people in",
      "manual": "Guest list (manual check-in)",
      "camera": "Camera",
      "hint": "Hold the guest's QR code inside the frame",
      "tapToContinue": "Tap to scan the next one",
      "alreadyAt": "Already checked in at {{time}}",
      "needsHttps": "The camera only works over HTTPS (the live site) or on localhost.",
      "permission": "Camera access was denied. Allow it in the browser settings and reload.",
      "noCamera": "No camera found.",
      "result": {
        "ok": "Welcome!",
        "already": "Already in",
        "waitlist": "Waitlist only",
        "wrongEvent": "Other event",
        "invalid": "Invalid code"
      }
    }
  },
  "notFound": {
    "title": "Lost the beat.",
    "text": "This page doesn't exist.",
    "back": "Back home"
  },
  "common": {
    "loading": "Loading…",
    "back": "Back",
    "external": "opens in a new tab",
    "close": "Close"
  },
  "errors": {
    "required": "Required",
    "email": "Please enter a valid email",
    "phone": "Please enter a valid phone number",
    "date": "Please choose a date",
    "number": "Please enter a number",
    "privacy": "Please accept the privacy policy"
  },
  "pill": {
    "next": "Next event",
    "live": "Live now",
    "startsIn": "Starts in",
    "d": "d",
    "h": "h",
    "m": "m"
  },
  "forms": {
    "sending": "Sending…",
    "errors": {
      "duplicate": "You're already on this list with this email address.",
      "closed": "The guestlist for this event is closed.",
      "past": "This event has already taken place.",
      "notFound": "This event is no longer available.",
      "tooManyPlusOnes": "Too many plus-ones for this event.",
      "rateLimited": "Too many attempts. Please try again in a few minutes.",
      "invalid": "Please check your entries.",
      "network": "No connection. Please check your internet and try again.",
      "unknown": "Something went wrong. Please try again."
    }
  },
  "guestlist": {
    "title": "Join Guestlist",
    "waitlistTitle": "Join Waitlist",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phone": "Phone",
    "plusOnes": "Plus-ones",
    "plusOnesHint": "Max. {{max}}",
    "decrease": "Fewer plus-ones",
    "increase": "More plus-ones",
    "privacy": "I have read the <1>privacy policy</1> and agree to my data being processed for the guestlist.",
    "newsletter": "Keep me posted about upcoming events (newsletter, optional).",
    "submit": "Put me on the list",
    "submitWaitlist": "Put me on the waitlist",
    "confirmedTitle": "You're on the list!",
    "confirmedText": "We've sent a confirmation to {{email}}. Bring a photo ID – see you there.",
    "waitlistDoneTitle": "You're on the waitlist",
    "waitlistDoneText": "The guestlist is full right now. We've sent a confirmation to {{email}} and will let you know if a spot opens up.",
    "done": "Done"
  },
  "instagram": {
    "eyebrow": "Follow",
    "title": "Instagram",
    "follow": "Clips, sets and behind the scenes – follow on Instagram.",
    "post": "Open post on Instagram"
  },
  "pass": {
    "title": "Guest pass",
    "qrLabel": "Guest pass QR code",
    "showAtDoor": "Show this QR code at the door – it covers you and your plus-ones.",
    "brightness": "Tip: turn up your screen brightness.",
    "open": "Open guest pass",
    "guests": "{{count}} person",
    "guests_other": "{{count}} people",
    "valid": "Valid",
    "checkedIn": "Checked in",
    "waitlist": "Waitlist",
    "waitlistText": "You're on the waitlist. If a spot opens up, you'll get an e-mail with your QR code.",
    "past": "This event has already taken place.",
    "eventDetails": "Event details",
    "notFoundTitle": "Pass not found.",
    "notFoundText": "The link is incomplete or no longer valid. Please use the link from your confirmation e-mail."
  },
  "errorBoundary": {
    "title": "Something didn't load.",
    "text": "Probably the website was just updated. Reloading fixes it.",
    "reload": "Reload"
  },
  "info": {
    "title": "Main info"
  },
  "stats": {
    "title": "Media statistics"
  },
  "venues": {
    "title": "Venues played",
    "austria": "Austria",
    "international": "International",
    "more": "Many more …"
  },
  "rider": {
    "title": "DJ rider"
  },
  "livesets": {
    "title": "Live DJ sets",
    "qr": "QR code for the live sets playlist on YouTube",
    "intro": "Full live sets from the clubs – all in one playlist.",
    "scan": "Scan with your phone or open the playlist directly.",
    "watch": "Watch on YouTube"
  },
  "lection": {
    "more": "Click for more",
    "tagline": "No genre, just vibes – hosted by Ajay"
  },
  "contact": {
    "title": "Contact",
    "cta": "Click here"
  },
  "artists": {
    "title": "Artist support",
    "more": "And many more!"
  },
  "produced": {
    "title": "Produced by Ajay",
    "more": "Many more …"
  },
  "links": {
    "title": "Links",
    "groups": {
      "social": "Socials",
      "streaming": "Streaming",
      "sets": "DJ sets",
      "drops": "Drops & tools"
    }
  }
}
